import { useContext } from 'react';
import { ClientSessionContext, type ClientSessionValue } from './ClientSessionContext';

export function useClientSession(): ClientSessionValue {
  const value = useContext(ClientSessionContext);
  if (!value) {
    throw new Error('useClientSession must be used inside the Partner Portal.');
  }

  return value;
}
